export default function trackWindow(store) {
  const commitMobilePortrait = () => {
    const { innerWidth, innerHeight } = window;

    store.commit('service/setMobilePortrait', innerWidth < 599 && innerWidth < innerHeight);
  };

  // initial set
  commitMobilePortrait();

  window.addEventListener('resize', commitMobilePortrait);
}
